var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-content"},[_c('router-view',{ref:"tab"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }